import React, { forwardRef, useImperativeHandle, Ref } from 'react';
import * as fromProjects from 'store/Projects';

import { ProjectSection } from 'components/Project/ProjectSection/ProjectSection';

interface IProps {
  outsideRef: Ref<any>;
  navSection: fromProjects.INavSection;
  animationReady: boolean;
}

const ProjectNavSectionComponent: React.FC<IProps> = forwardRef(({ navSection, animationReady, outsideRef, ...props }, Cref) => {
  useImperativeHandle(Cref, () => ({}));
  const getContentSections = () => (
    navSection.contentSection.map((contentSection: fromProjects.IContentSection, index) => {
      const projectSectionProps = {
        contentSection,
        animationReady,
      };
      return <ProjectSection key={index} {...projectSectionProps} />;
    })
  );

  return (
    <section ref={outsideRef} className='projectNavSectionWrapper'>
      {getContentSections()}
    </section>
  );
});

export const ProjectNavSection = ProjectNavSectionComponent;
